// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
/* Store Custom Code - End */

const padding = pxToRemArray([20]); /* Store Custom Code */

const modal: Styleguide["modal"] = {
    defaultProps: {
        headlineTypographyProps: {
            forwardAs: "p",
            variant: null as any,
        },
        closeButtonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${focusUpdateStyles(true)}
                transition: ${transitionHoverStyles("color")};
                flex-shrink: 0;
                color: ${getColor("text.link")}; /* Store Custom Code */

                ${breakpointValues(
                    padding.map(x => (x ? `calc(${x} / 2) ${x}` : x)),
                    "padding",
                )}

                ${breakpointValues(
                    padding.map(x => (x ? `calc(-${x} / 2) -${x} calc(-${x} / 2) auto` : x)),
                    "margin",
                )}

                &:hover {
                    color: ${getColor("text.linkHover")}; /* Store Custom Code */
                }
            `,
        },
        closeButtonIconProps: {
            src: Close,
            size: 18,
        },
        cssOverrides: {
            modalTitle: css`
                align-items: flex-start;
                /* Store Custom Code - Start */
                text-transform: uppercase;
                ${typographyTitleStyles(pxToRemArray([18, null, 20]))}
                /* Store Custom Code - End */

                ${({ theme }) => css`
                    /* Store Removed - font-size */
                    font-weight: ${theme.design.typography.weight.extrabold}; /* Store Custom Code */
                    line-height: ${theme.design.typography.lineHeight.small};

                    /* Store Removed - breakpoint md */
                `}

                ${breakpointValues(padding, "padding")} /* Store Custom Code */
            `,
            modalContent: css`
                ${breakpointValues(padding, "padding")}
            `,
            /* Store Custom Code - Start */
            modalBody: css`
                ${({ theme }) => css`
                    ${breakpoint("md")} {
                        box-shadow: ${theme?.shadows.mid20};
                    }
                `}
            `,
            /* Store Custom Code - End */
        },
    },
};

export default modal;
